'use es6';

import { DragSource } from 'react-dnd';
import NopeZone from 'InpageEditorUI/components/NopeZone';
import { dragTypes } from 'InpageEditorUI/lib/layoutSection/constants';
import { draggingStartedAndDeselectExisting as draggingStartedAndDeselectExistingAction, draggingStoppedAndReselectIfNeeded as draggingStoppedAndReselectIfNeededAction } from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { getEmptyImage } from 'react-dnd-ipeui-backend';
import { connect } from 'react-redux';
import { getIsAnythingDragging } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { updateSelectedItem as updateSelectedItemAction } from 'ContentEditorUI/redux/actions/selectionActions';
import { getNodePositionsByTreeId } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { generateTilesOutsideOf } from 'layout-dnd-utils/geometry/tiling';
import { getElementBounds } from 'layout-dnd-utils/dom/bounds';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const dragSource = {
  beginDrag(props, monitor, component) {
    const {
      hoveredNodeInfo,
      draggingStartedAndDeselectExisting,
      targetedLayoutSectionId
    } = props;
    const dragItem = {
      dragId: hoveredNodeInfo.id,
      dragParentId: hoveredNodeInfo.parentId,
      isColumn: hoveredNodeInfo.isColumn,
      isRow: hoveredNodeInfo.isRow,
      isTopMostRow: hoveredNodeInfo.isTopMostRow,
      originLayoutSectionId: targetedLayoutSectionId
    };

    // Save the hover info to keep rendering while dragging (otherwise if the DOM being dragged goes
    // away or is restyled significantly, then the drag will stop)
    component.hoveredNodeInfoFromDrag = hoveredNodeInfo;
    draggingStartedAndDeselectExisting(dragItem);
    return dragItem;
  },
  canDrag(props) {
    return props.isInDefaultBreakpointMode && !props.isSmartContentPreview;
  },
  endDrag(props, monitor, component) {
    const {
      draggingStoppedAndReselectIfNeeded
    } = props;
    delete component.hoveredNodeInfoFromDrag;
    draggingStoppedAndReselectIfNeeded(monitor.getItem(), monitor.didDrop());
  }
};
function dragCollect(dndConnect, monitor) {
  return {
    connectDragPreview: dndConnect.dragPreview(),
    connectDragSource: dndConnect.dragSource(),
    isDragging: monitor.isDragging()
  };
}
const mapStateToProps = state => ({
  isAnythingDragging: getIsAnythingDragging(state),
  nodePositionsByTreeId: getNodePositionsByTreeId(state)
});
const mapDispatchToProps = {
  draggingStartedAndDeselectExisting: draggingStartedAndDeselectExistingAction,
  draggingStoppedAndReselectIfNeeded: draggingStoppedAndReselectIfNeededAction,
  updateSelectedItem: updateSelectedItemAction
};
class LayoutSectionNopeZoneContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tiles: []
    };
  }
  componentDidMount() {
    const {
      connectDragPreview
    } = this.props;
    connectDragPreview(getEmptyImage(), {
      captureDraggingState: true
    });
  }
  componentDidUpdate(prevProps) {
    const {
      nodePositionsByTreeId,
      isAnythingDragging
    } = this.props;
    const nodePositionsChanged = prevProps.nodePositionsByTreeId !== nodePositionsByTreeId;
    const justStartedDragging = !prevProps.isAnythingDragging && isAnythingDragging;
    if (justStartedDragging || nodePositionsChanged && isAnythingDragging) {
      this.updateTiles();
    }
  }
  updateTiles() {
    const {
      nodePositionsByTreeId
    } = this.props;
    const documentBounds = getElementBounds(document.documentElement, {
      applyScrollOffset: true
    });
    const positionForAllDndAreas = Object.keys(nodePositionsByTreeId).map(layoutSectionId => {
      return nodePositionsByTreeId[layoutSectionId][layoutSectionId];
    });
    if (positionForAllDndAreas.length > 0) {
      let tiles;
      try {
        tiles = generateTilesOutsideOf(documentBounds, positionForAllDndAreas);
      } catch (err) {
        console.error('Error generating nope zone tiles: ', err);
      }
      if (tiles) {
        this.setState({
          tiles
        });
      }
    } else {
      this.setState({
        tiles: []
      });
    }
  }
  render() {
    const {
      isAnythingDragging
    } = this.props;
    const {
      tiles
    } = this.state;
    return /*#__PURE__*/_jsx(View, {
      display: isAnythingDragging ? 'block' : 'none',
      children: tiles.map((tile, i) => /*#__PURE__*/_jsx(NopeZone, {
        top: tile.top,
        bottom: tile.bottom,
        right: tile.right,
        left: tile.left
      }, i))
    });
  }
}
LayoutSectionNopeZoneContainer.propTypes = {
  connectDragPreview: PropTypes.func.isRequired,
  isAnythingDragging: PropTypes.bool.isRequired,
  nodePositionsByTreeId: PropTypes.object
};
export default connect(mapStateToProps, mapDispatchToProps)(DragSource(dragTypes.EXISTING_ITEM, dragSource, dragCollect)(LayoutSectionNopeZoneContainer));